var _sentryCollisionFreeGlobalObject = "object" != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "eOXSOTGfj23bus0qJOcYo"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
// 우리 코드로 수정 불가능한 외부 SDK 내부에서 발생하는 에러는 Sentry 보고에서 제외한다.
// - clarity.js: GTM으로 주입되는 Microsoft Clarity 내부 버그 (iOS 인앱 웹뷰 등에서 발생)
// - navigation_performance_logger: Instagram/Meta 인앱 브라우저가 페이지에 inject하는
//   성능 계측 스크립트. WebView Java 객체가 GC되면 "Java object is gone" 에러 발생
// - dist/prod/v2/mtm: Megadata(cdn.megadata.co.kr) 마케팅 트래커 SDK가 JSON.parse 실패로
//   throw. 운영팀이 GTM 등으로 통합한 외부 트래커 (우리 src/ 코드엔 통합 없음)
const IGNORED_THIRD_PARTY_SCRIPTS = [
    "clarity.js",
    "navigation_performance_logger",
    "dist/prod/v2/mtm"
];
// 우리 React 코드가 아닌 외부 컨텐츠(AdminJS 랜딩 HTML 인라인 스크립트 등)에서 발생하는
// 에러 메시지 패턴을 차단한다. AdminJS 측 HTML 가드 수정이 별도로 필요.
// - window.webkit.messageHandlers: iOS Swift WKWebView 브릿지 호출 코드를 일반 브라우저
//   (인스타 인앱 등)에서 실행 시 발생. 우리 솔북 앱은 React Native 기반이라
//   window.ReactNativeWebView 를 사용하므로 webkit 브릿지 호출은 src/ 코드에 없음.
//   닫힘 따옴표까지 포함해서 정확히 .messageHandlers 에서 끝나는 경우만 매칭
//   (.foo 등 추가 접근이 붙은 케이스는 새로 생긴 진짜 버그일 수 있으므로 보고 유지)
// - MetaMask: 사용자가 설치한 MetaMask 브라우저 확장이 자체 세션 복구에 실패할 때
//   inpage.js 가 페이지 global scope로 throw. 우리 src/ 에 MetaMask 통합 없음
const IGNORED_ERROR_MESSAGE_PATTERNS = [
    "evaluating 'window.webkit.messageHandlers')",
    "Failed to connect to MetaMask",
    "MetaMask extension not found"
];
const isFromIgnoredThirdParty = (event)=>{
    var _event_exception, _event_exception_values;
    var _value_stacktrace_frames, _event_exception_values_flatMap;
    const frames = (_event_exception_values_flatMap = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.flatMap((value)=>{
        var _value_stacktrace;
        return (_value_stacktrace_frames = (_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : _value_stacktrace.frames) !== null && _value_stacktrace_frames !== void 0 ? _value_stacktrace_frames : [];
    })) !== null && _event_exception_values_flatMap !== void 0 ? _event_exception_values_flatMap : [];
    return frames.some((frame)=>{
        return IGNORED_THIRD_PARTY_SCRIPTS.some((script)=>{
            var _frame_filename, _frame_abs_path;
            return ((_frame_filename = frame.filename) === null || _frame_filename === void 0 ? void 0 : _frame_filename.includes(script)) || ((_frame_abs_path = frame.abs_path) === null || _frame_abs_path === void 0 ? void 0 : _frame_abs_path.includes(script));
        });
    });
};
const hasIgnoredErrorMessage = (event)=>{
    var _event_exception, _event_exception_values;
    var _value_value, _event_exception_values_map;
    const messages = (_event_exception_values_map = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.map((value)=>(_value_value = value.value) !== null && _value_value !== void 0 ? _value_value : "")) !== null && _event_exception_values_map !== void 0 ? _event_exception_values_map : [];
    return messages.some((message)=>IGNORED_ERROR_MESSAGE_PATTERNS.some((pattern)=>message.includes(pattern)));
};
Sentry.init({
    dsn: SENTRY_DSN,
    // tracesSampleRate: 1.0,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend (event) {
        if (isFromIgnoredThirdParty(event)) return null;
        if (hasIgnoredErrorMessage(event)) return null;
        return event;
    }
});
